import { DeepPartial } from '@apollo/client/utilities';
import {
  GetStagingLottiSubscription,
  GetStagingSottoscrizioneQuery,
  GetStagingSottoscrizioniQuery,
} from '../../../../../_core/_graphql/generated';

export type StagingState = {
  role?:
  | 'user'
  | 'manager'
  | 'anonymous'
  | 'installatore'
  | 'tecnico'
  | 'segnalatore'
  | 'amico';

  lotto_enabled: boolean;

  sottoscrizioni_loading: boolean;
  sottoscrizioni_data?: GetStagingSottoscrizioniQuery['staging_sottoscrizione_list_mv'];
  sottoscrizioni_version: number;
  sottoscrizioni_lotto_id?: string;
  sottoscrizioni_filter: boolean;
  sottoscrizioni_filter_data: any;

  selected_sottoscrizione_loading: boolean;
  selected_sottoscrizione?: DeepPartial<
    GetStagingSottoscrizioneQuery['staging_sottoscrizione_by_pk']
  >;

  lotti_loading: boolean;
  lotti_data?: GetStagingLottiSubscription['staging_lotto'];
  lotti_filter: boolean;
  lotti_filter_data: any;

  tabella_sottoscrizioni_ui?: { expandedGroups: (string | null)[]; scrollY: number };
  tabella_wait_refresh_loading: boolean;
  tabella_wait_refresh_target_version?: number;

  failure?: any;
};

export const initialStagingState: StagingState = {
  role: undefined,

  lotto_enabled: false,

  sottoscrizioni_loading: true,
  sottoscrizioni_data: undefined,
  sottoscrizioni_version: 0,
  sottoscrizioni_lotto_id: undefined,
  sottoscrizioni_filter: false,
  sottoscrizioni_filter_data: undefined,

  selected_sottoscrizione_loading: true,
  selected_sottoscrizione: undefined,

  lotti_loading: true,
  lotti_data: undefined,
  lotti_filter: false,
  lotti_filter_data: undefined,

  tabella_sottoscrizioni_ui: undefined,
  tabella_wait_refresh_loading: false,
  tabella_wait_refresh_target_version: undefined,

  failure: undefined,
};

